import { useEffect, useMemo, useState } from 'react';

interface UseClockOptions {
  timeZone?: string;
  intervalMs?: number;
}

/**
 * Returns a live formatted clock string for the given timezone.
 * Updates once per second by default.
 */
export function useClock({
  timeZone = 'Europe/Warsaw',
  intervalMs = 1000,
}: UseClockOptions = {}): string {
  const [now, setNow] = useState<Date>(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  const formatter = useMemo(
    () =>
      new Intl.DateTimeFormat('en-GB', {
        timeZone,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }),
    [timeZone]
  );

  return formatter.format(now);
}
